/**
 * @generated SignedSource<<50b65d47d6c6bdf9ab1002d27294f138>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type flavorProvider_getFlavorsQuery$variables = {};
export type flavorProvider_getFlavorsQuery$data = {
  readonly getFlavors: ReadonlyArray<{
    readonly flavor: string;
    readonly id: string;
    readonly name: string;
  }>;
};
export type flavorProvider_getFlavorsQuery = {
  response: flavorProvider_getFlavorsQuery$data;
  variables: flavorProvider_getFlavorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FlavorObjectType",
    "kind": "LinkedField",
    "name": "getFlavors",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flavor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "flavorProvider_getFlavorsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "flavorProvider_getFlavorsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f95a29e462501103a6cfdc67b0a01b0f",
    "id": null,
    "metadata": {},
    "name": "flavorProvider_getFlavorsQuery",
    "operationKind": "query",
    "text": "query flavorProvider_getFlavorsQuery {\n  getFlavors {\n    id\n    name\n    flavor\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc661a4292a014b4e6760d6c1396c0f9";

export default node;
